import React from "react";

const QRCodeBorder: React.FC<{}> = () => (
  <svg className="QRCodeBorder" width="180px" height="180px" viewBox="0 0 180 180">
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="QRCodeBorder-1">
        <stop stopColor="#79B17D" offset="0%" />
        <stop stopColor="#8CB4D6" offset="100%" />
      </linearGradient>
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Full-Screen" transform="translate(-528, -724)" stroke="url(#QRCodeBorder-1)" strokeWidth="5">
        <rect id="Rectangle" x="530.5" y="726.5" width="175" height="175" rx="23" />
      </g>
    </g>
  </svg>
);

export default QRCodeBorder;
